<template>
  <v-textarea
    :auto-grow="autoGrow"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    :error-messages="errorMessages"
    :label="label|capitalize"
    :readonly="disabled"
    :name="name"
    :ref="name"
    :required="required"
    :value="computedValue"
    :spellcheck="spellcheck"
    @blur="onBlur($event)"
    @focus="onFocus()"
    @input="onInput($event)"
    :class="{
      'nx-form-text': true,
      'v-input--is-disabled': disabled,
    }"
    data-vv-value-path="value"
    v-validate="validation"
    data-vv-validate-on="input|blur"
    v-bind="$attrs"
  ></v-textarea>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import { eventBus, CONTENT_EDITOR_PREVIEW_TOGGLE } from '@/events';

export default {
  name: 'nx-form-textarea',
  mixins: [FormElement],
  props: {
    autoGrow: {
      type: Boolean,
    },
    prettyJSON: {
      type: Boolean,
      default: true,
    },
    spellcheck: {
      type: Boolean,
    },
  },
  computed: {
    computedValue() {
      if (!this.prettyJSON) {
        return this.value;
      }
      try {
        return JSON.stringify(JSON.parse(this.value), null, 2);
      } catch (e) {
        return this.value;
      }
    },
  },
  methods: {
    calculateInputHeight() {
      if (this.$refs[this.name]) {
        this.$refs[this.name].calculateInputHeight();
      }
    },
  },
  watch: {
    computedValue: {
      handler() {
        if (!this.autoGrow) {
          return;
        }
        setTimeout(this.calculateInputHeight, 100);
      },
      immediate: true,
    },
  },
  async mounted() {
    // Hack fix for autogrow, sometimes is not working properly :-(
    if (this.autoGrow) {
      eventBus.$on(
        CONTENT_EDITOR_PREVIEW_TOGGLE,
        () => setTimeout(this.calculateInputHeight, 100),
      );
      this.intervalId = setTimeout(this.calculateInputHeight, 500);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>
